import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { coreApiRoutesProvider } from '@app/core/configs/api-routes';
import { coreConfigProvider } from '@app/core/configs/core.config';
import { I18nProviders } from '@app/core/configs/i18n.config';
import { httpInterceptorProviders } from '@app/core/interceptors';
import { AuthService } from '@app/core/services/auth.service';
import { FormBuilderService } from '@app/core/services/form-builder.service';
import { HttpService } from '@app/core/services/http.service';
import { LogService } from '@app/core/services/log.service';
import { PermissionService } from '@app/core/services/permission.service';
import { RoleService } from '@app/core/services/role.service';
import { UtilsService } from '@app/core/services/utils.service';
import { ValidationService } from '@app/core/services/validation.service';
import { WebStorageService } from '@app/core/services/web-storage.service';
import { CoreState } from '@app/core/store/core.reducer';
import { SessionState } from '@app/core/store/session/session.reducer';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  declarations: [],
  exports: [],
  imports: [NgxsModule.forFeature([CoreState, SessionState])],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        LogService,
        httpInterceptorProviders,
        coreConfigProvider,
        coreApiRoutesProvider,
        UtilsService,
        WebStorageService,
        HttpService,
        PermissionService,
        RoleService,
        AuthService,
        I18nProviders,
        ValidationService,
        FormBuilderService,
      ],
    };
  }

  constructor(
    @Optional()
    @SkipSelf()
    core: CoreModule,
  ) {
    if (core instanceof CoreModule) {
      throw new Error(
        "Can't inject core module in a child module, core module should always be injected in root module!",
      );
    }
  }
}
